import { createContext } from "react";
import { getDefaultCurrency } from "./LocaleService";
var CurrencyContext = createContext({
  get defaultCurrency() {
    return getDefaultCurrency() || "USD";
  }
});
export var CurrencyContextProvider = CurrencyContext.Provider;
export var CurrencyContextConsumer = CurrencyContext.Consumer;
export default CurrencyContext;